import { Button, buttonVariants } from '@/app/common/components/Button'
import { AppRoutePaths } from '@/routing/route_paths'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import FamilyWizardLayout from '../../FamilyWizardLayout'
import useTaxableIncomeDocumentParams from '../hooks/useTaxableIncomeDocumentParams'
import { SkipVerification } from '../skip-verification/SkipVerification'
import { LightningIcon, LockIcon } from '@/app/common/icons/general'

export function ManualUploadDescription() {
  const { t: translate } = useTranslation()
  const [skip, setSkip] = useState(false)
  const { onEnterForm } = useTaxableIncomeDocumentParams()

  if (skip) {
    return (
      <SkipVerification
        onCancel={() => {
          setSkip(false)
        }}
      />
    )
  } 

  return (
    <div>
      <FamilyWizardLayout>
        <FamilyWizardLayout.Header>
          <h1>{translate('manual_income_verification')}</h1>
        </FamilyWizardLayout.Header>
        <FamilyWizardLayout.Content>
          <h2 className="text-lg text-gray-800 font-medium">
            {translate('determine_priority')}
          </h2>
          <div className="flex items-center mt-6">
            <LightningIcon />
            <div className="ml-2 font-medium">
              {translate('what_to_expect')}
            </div>
          </div>
          <p className="text-gray-800 text-sm mt-1">
            {translate('upload_for_manual_review')}
          </p>
          <div className="mt-4">
            <div className="flex items-center">
              <LockIcon />
              <div className="ml-2 font-medium">
                {translate('what_you_need')}
              </div>
            </div>
            <p className="text-gray-800 text-sm mt-1">
              {translate('documents_recognized')}
            </p>
          </div>
        </FamilyWizardLayout.Content>
        <FamilyWizardLayout.ActionBar className="flex-col space-y-2">
          <Button
            onClick={() => {
              onEnterForm(
                AppRoutePaths.family_application.income_verification
                  .capture_instructions,
                'form_1040'
              )
            }}
            className={buttonVariants({
              variant: 'primary',
            })}
          >
            {translate('continue')}
          </Button>
          <Button
            onClick={() => {
              setSkip(true)
            }}

            className="w-full h-12"
            variant={'text'}
            size={"text"}
          >
            {translate('skip_income_verification')}
          </Button>
        </FamilyWizardLayout.ActionBar>
      </FamilyWizardLayout>
    </div>
  )
}
